module.exports = __webpack_public_path__ + "static/fonts/OpenSansitalic.20ab65ce.ttf";